export default {
  name: "Crowlyn, s.r.o.",
  titleTemplate: "Crowlyn",
  description: "Web development",
};
